import { useContext, useEffect, useRef } from 'react'
import { CesiumViewerContext } from '../cesiumviewer/CesiumViewer'
import { CoordinateConverter } from '../../../../../util/coordinateConverter';
import {Color, Entity, CallbackProperty, Cartesian3, ArcType} from 'cesium';
interface Props {
    pos: number[];
    ground: number;
    azi: number;
    ele: number;
    range: number;
    width: number;
    color: string;
}

function getColor(color: string | null) {
    if (color !== null) {
        return Color.fromCssColorString(color);
    }
    return Color.AQUA
}

export default function AOA(props: Props) {
    const viewer = useContext(CesiumViewerContext);
    const entityRef = useRef<Entity>();
    const converter = new CoordinateConverter();
    useEffect(() => {
        if (!viewer) {
            return () => { }
        }
        props.pos[2] = 0.0;
        const posArray = converter.getLine3D(props.pos, props.azi, props.ele, props.range);
        const positions = new CallbackProperty(() => {
            return Cartesian3.fromDegreesArrayHeights([
                posArray[0][0],
                posArray[0][1],
                posArray[0][2] - props.ground,
                posArray[1][0],
                posArray[1][1],
                posArray[1][2] - props.ground,
           ]);
        }, true)
        const material = getColor(props.color)
        const e = viewer.entities.add({
            polyline: {
                width: props.width,
                positions,
                material,
                arcType: ArcType.NONE
            }
        } as any);
        entityRef.current = e;
        return () => { viewer!.entities.remove(e) }
    }, [viewer]);

    useEffect(() => {
        if (!entityRef.current) {
            return;
        }
        const entity = entityRef.current;
        props.pos[2] = 0.0;
        const posArray = converter.getLine3D(props.pos, props.azi, props.ele, props.range);
        (entity as any).polyline.positions.setCallback(() => {
            return Cartesian3.fromDegreesArrayHeights([
                posArray[0][0],
                posArray[0][1],
                posArray[0][2] - props.ground,
                posArray[1][0],
                posArray[1][1],
                posArray[1][2] - props.ground,
            ])
        }, false);
    }, [props.pos, props.azi, props.ele, props.range]);
    
    useEffect(() => {
        if (!entityRef.current) {
            return;
        }
        const entity = entityRef.current;
        (entity as any).polyline.width.setValue(props.width);
    }, [props.width]);

    useEffect(() => {
        if (!entityRef.current) {
            return;
        }
        const entity = entityRef.current;
        (entity as any).polyline.material.color.setValue(getColor(props.color));
    }, [props.color]);

    return null;
}
